<template functional>
  <div class="relative mb-12">
    <div class="text-xl font-bold text-text leading-tight  mb-8">
      Подключение банков пока ограничено!
    </div>
    <p class="text-md text-text-label leading-8 pr-15">
      К сожалению, MoneyKeeper вынужден приостановить импорт операций из банков в связи с банковскими ограничениями.
      Мы восстановим интеграции с банками и платежными системами, когда это станет возможным.
      <br><br>
      Вы по-прежнему можете добавлять операции вручную, строить отчеты, следить за бюджетом и целями 🤍
    </p>
  </div>
</template>

<script>
export default {
  name: "BanksIntegrationsUnavailableTip",
}
</script>